import type { TenantConfig } from '@webmono/storefront-ui/types'

export const mariasTaqueria: TenantConfig = {
  id: 'marias',
  slug: 'marias-taqueria',
  name: "Maria's Taqueria",
  tagline: 'Authentic Mexican Street Food',
  description: 'Experience the vibrant flavors of Mexico with our authentic street tacos, burritos, and homemade salsas. Made fresh daily with love.',

  branding: {
    logo: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=200&h=200&fit=crop',
    logoAlt: "Maria's Taqueria Logo",
    favicon: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=32&h=32&fit=crop',
    bannerImage: 'https://images.unsplash.com/photo-1504544750208-dc0358e63f7f?w=1200&h=400&fit=crop',
    ogImage: 'https://images.unsplash.com/photo-1504544750208-dc0358e63f7f?w=1200&h=630&fit=crop',
  },

  theme: {
    colors: {
      primary: '#E85D04',
      primaryForeground: '#FFFFFF',
      secondary: '#FFF3E0',
      secondaryForeground: '#E85D04',
      accent: '#2D6A4F',
      accentForeground: '#FFFFFF',
      background: '#FFFBF5',
      foreground: '#1A1A1A',
      muted: '#F5F0EB',
      mutedForeground: '#6B6B6B',
      card: '#FFFFFF',
      cardForeground: '#1A1A1A',
      border: '#E8E0D8',
      input: '#E8E0D8',
      ring: '#E85D04',
      destructive: '#DC2626',
      destructiveForeground: '#FFFFFF',
      success: '#16A34A',
      successForeground: '#FFFFFF',
      warning: '#F59E0B',
      warningForeground: '#FFFFFF',
    },
    fonts: {
      heading: 'Poppins',
      body: 'Inter',
      mono: 'JetBrains Mono',
    },
    radius: 'lg',
    spacing: 'normal',
  },

  contact: {
    address: '2847 Mission Street',
    city: 'San Francisco',
    state: 'CA',
    zip: '94110',
    country: 'USA',
    phone: '(415) 555-0123',
    email: 'hola@mariastaqueria.com',
    coordinates: { lat: 37.7515, lng: -122.4180 },
  },

  operations: {
    timezone: 'America/Los_Angeles',
    hours: {
      monday: { open: '10:00', close: '21:00' },
      tuesday: { open: '10:00', close: '21:00' },
      wednesday: { open: '10:00', close: '21:00' },
      thursday: { open: '10:00', close: '21:00' },
      friday: { open: '10:00', close: '22:00' },
      saturday: { open: '10:00', close: '22:00' },
      sunday: { open: '11:00', close: '20:00' },
    },
    businessHours: { open: '10:00', close: '21:00' },
    taxRate: 0.0875,
    currency: 'USD',
    locale: 'en-US',
  },

  features: {
    pickup: true,
    delivery: true,
    tableOrdering: true,
    scheduledOrders: true,
    loyalty: false,
    promoCode: true,
    guestCheckout: true,
    accountRequired: false,
    tipping: true,
    specialInstructions: true,
    dietaryFilters: true,
  },

  fulfillment: {
    pickup: {
      enabled: true,
      leadTimeMinutes: 15,
      maxScheduleDays: 7,
    },
    delivery: {
      enabled: true,
      provider: 'in-house',
      flatFeeCents: 499,
      minimumOrderCents: 1500,
      radiusMiles: 5,
      leadTimeMinutes: 35,
      estimateMinutes: { min: 25, max: 40 },
    },
    tableService: {
      enabled: true,
      tableCount: 12,
      autoCloseMinutes: 120,
    },
  },

  tipping: {
    enabled: true,
    presets: [15, 18, 20, 25],
    allowCustom: true,
    defaultPresetIndex: 1,
  },

  i18n: {
    defaultLocale: 'en',
    supportedLocales: ['en', 'es'],
    translations: {
      en: {
        'cart.title': 'Your Order',
        'cart.empty': 'Your cart is empty',
        'checkout.pickup': 'Pickup',
        'checkout.delivery': 'Delivery',
        'checkout.table': 'Table Service',
        'order.confirmed': 'Order Confirmed!',
        'menu.search': 'Search menu...',
      },
      es: {
        'cart.title': 'Tu Pedido',
        'cart.empty': 'Tu carrito está vacío',
        'checkout.pickup': 'Recoger',
        'checkout.delivery': 'Entrega',
        'checkout.table': 'Servicio de Mesa',
        'order.confirmed': '¡Pedido Confirmado!',
        'menu.search': 'Buscar en el menú...',
      },
    },
  },

  legal: {
    privacyPolicyUrl: '/privacy',
    termsUrl: '/terms',
    allergenDisclaimer: 'Our kitchen handles common allergens including wheat, dairy, eggs, and nuts. Please inform us of any allergies.',
  },

  social: {
    instagram: 'https://instagram.com/mariastaqueria',
    facebook: 'https://facebook.com/mariastaqueria',
    yelp: 'https://yelp.com/biz/marias-taqueria',
  },
}
